<div class="toggleDs__cont toggleDs__cont--{{size}}">
  <label class="toggleDs__switch toggleDs__switch--{{size}}" [class.disabled]="isDisabled">
    <input class="input" [disabled]="isDisabled" type="checkbox" [checked]="isActive" (click)="toggleOnChange.emit(!isActive)">
    <span class="bg bg--{{size}}">
      @if (icon) {
        <app-ds-icon
          class="icon icon--{{size}}"
          [icon]="icon"
          [size]="10">
        </app-ds-icon>
      }
    </span>
  </label>
</div>